import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { parse, differenceInYears, intervalToDuration } from 'date-fns';

@Component({
    selector: 'app-date-of-birth',
    templateUrl: './date-of-birth.component.html',
    styleUrls: ['./date-of-birth.component.scss'],
    standalone: false
})
export class DateOfBirthComponent implements OnInit {
  dateOfBirthForm: FormGroup;
  invalidDobMsg = '';
  currentYear = new Date().getFullYear();
  day: any;
  month: any;
  year: any;

  @Input() parentForm: FormGroup;

  @Output()
  public dateChanged: EventEmitter<string> = new EventEmitter<string>();

  @Input() set date(date: any) {
    const dateDetails = date && date.split('-');
    if (dateDetails) {
      this.year = dateDetails[0];
      this.month = dateDetails[1];
      this.day = dateDetails[2];
    } else {
      this.dateChanged.emit('Entered DOB is not valid');
    }
    this.dateOfBirthForm = this.fb.group({
      day: [
        this.day,
        [
          Validators.required,
          Validators.pattern(/^[0-9]\d*$/),
          Validators.min(1),
          Validators.max(31),
        ],
      ],
      month: [
        this.month,
        [
          Validators.required,
          Validators.pattern(/^[0-9]\d*$/),
          Validators.min(1),
          Validators.max(12),
        ],
      ],
      // year: [this.year, [Validators.required, Validators.pattern(/^\d{4}$/), Validators.min(this.currentYear - 100), Validators.max(this.currentYear - 18)]]
      year: [this.year, [Validators.required, Validators.pattern(/^\d{4}$/)]],
    });

    if (dateDetails) {
      this.validateAndReturnDob();
    }

    if (
      this.isValidateDOB(this.day, this.month, this.year) !==
        'Entered DOB is not valid' &&
      this.isValidateDOB(this.day, this.month, this.year) !== 'min' &&
      this.isValidateDOB(this.day, this.month, this.year) !== 'max'
    ) {
      this.dateOfBirthForm.get('day')?.disable();
      this.dateOfBirthForm.get('month')?.disable();
      this.dateOfBirthForm.get('year')?.disable();
    } else {
      this.dateOfBirthForm.get('day')?.enable();
      this.dateOfBirthForm.get('month')?.enable();
      this.dateOfBirthForm.get('year')?.enable();
    }
  }

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.dateOfBirthForm = this.fb.group({
      day: [
        this.day,
        [
          Validators.required,
          Validators.pattern(/^[0-9]\d*$/),
          Validators.min(1),
          Validators.max(31),
        ],
      ],
      month: [
        this.month,
        [
          Validators.required,
          Validators.pattern(/^[0-9]\d*$/),
          Validators.min(1),
          Validators.max(12),
        ],
      ],
      // year: [this.year, [Validators.required, Validators.pattern(/^\d{4}$/), Validators.min(this.currentYear - 100), Validators.max(this.currentYear - 18)]]
      year: [this.year, [Validators.required, Validators.pattern(/^\d{4}$/)]],
    });

    this.parentForm.addControl('dateOfBirth', this.dateOfBirthForm);

    if (this.day || this.month || this.year) {
      this.validateAndReturnDob();
    }
  }

  validateAndReturnDob() {
    if (this.dateOfBirthForm?.valid) {
      const day = this.dateOfBirthForm.value.day;
      const month = this.dateOfBirthForm.value.month;
      const year = this.dateOfBirthForm.value.year;
      this.invalidDobMsg = this.isValidateDOB(day, month, year);
    } else {
      this.invalidDobMsg = 'Entered DOB is not valid';
    }

    if (this.invalidDobMsg) {
      this.dateChanged.emit(this.invalidDobMsg);
    } else {
      const date = `${this.dateOfBirthForm.value.year}-${this.dateOfBirthForm.value.month}-${this.dateOfBirthForm.value.day}`;
      this.dateChanged.emit(date);
    }
  }

  isValidateDOB(day: number, month: number, year: number): string {
    if (month < 1 || month > 12 || day < 1 || day > 31) {
      return 'Entered DOB is not valid';
    }

    if (
      (month === 4 || month === 6 || month === 9 || month === 11) &&
      day > 30
    ) {
      return 'Entered DOB is not valid';
    }

    if (month === 2) {
      const isLeapYear = (year % 4 === 0 && year % 100 !== 0) || year % 4 === 0;

      if ((isLeapYear && day > 29) || (!isLeapYear && day > 28)) {
        return 'Entered DOB is not valid';
      }
    }

    const date = parse(`${year}-${month}-${day}`, 'yyyy-MM-dd', new Date());
    const age = this.calculateAge(date);
    if (age < 18) {
      return 'min';
    } else if (age > 100) {
      return 'max';
    } else if (age == 100) {
      const { years, months, days } = intervalToDuration({
        start: date,
        end: new Date(),
      });
      if (months || days) {
        return 'max';
      }
    }
    return '';
  }

  calculateAge(dateOfBirth: Date): number {
    const age = differenceInYears(new Date(), dateOfBirth);
    return age;
  }
}
